/*************************/
/** GLOBALS & CONSTANTS **/
/*************************/

//determine mobile user
let MOBILE_USER = false;
if (/Mobi/i.test(navigator.userAgent) || /Android/i.test(navigator.userAgent)) {
  MOBILE_USER = true;
}
const COMPARE_COOKIE = 'wll_compare_products';
const PLACEHOLDER_IMAGE = "//www.wholelattelove.com/cdn/shop/files/espresso_machine_silo_500x.png?v=14682899897888560761";
const BASE_STORE_URL = 'https://www.wholelattelove.com';
let ORACLE_BASE_URL = 'https://sg-oracle.herokuapp.com';
if (BASE_STORE_URL.includes('-dev')) {
  ORACLE_BASE_URL = 'https://sg-oracle-dev.herokuapp.com';
}
let OVERFLOW_PRODUCTS = [];
let TABLE_PRODUCTS = [];
let RECOMMENDED_PRODUCT_IDS = [];
const MOBILE_MAX_PRODUCTS = 2;
let USING_URL_PARAMS = false;
let NULL_DATA = ['N/A', 'None'];
const RECOMMENDED_ERROR_MSG = 'All recommended products have been viewed.';

/*************************/
/** COOKIE & URL CHECKS **/
/*************************/

document.addEventListener('DOMContentLoaded', (event) => {
  /* Using URL pararms if set, or try using cookie */
  let urlProductParams = new URL(window.location.href).searchParams.get('products');
  if (!!urlProductParams) {
    USING_URL_PARAMS = true;
    //let cookieProducts = urlProductParams.split(',');
    let cookieProducts = atob(urlProductParams).split(',');
    let tableProductIds = [...cookieProducts];
    let overflowProductIds = [];
    //set the cookie
    let expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7);
    SetCookie(COMPARE_COOKIE, cookieProducts.toString(), expirationDate, '/');
    //if mobile and more than max products, add to overflow array
    if (MOBILE_USER && cookieProducts.length > MOBILE_MAX_PRODUCTS) {
      //create overflow array
      for (let i = MOBILE_MAX_PRODUCTS; i < tableProductIds.length; i++) {
        overflowProductIds.push(tableProductIds[i]);
      }
      //trim table array
      let j = tableProductIds.length;
      while (j--) {
        if (j >= MOBILE_MAX_PRODUCTS) {
          tableProductIds.splice(j, 1);
        }
      }
    }
    //show recommended products if desktop
    if (MOBILE_USER === false) {
      showRecommendedProductBtn();
    }
    //send request
    if (!!cookieProducts.length) getComparisonProducts(cookieProducts, tableProductIds, overflowProductIds);
  } else if (!!GetCookie('wll_compare_products')) {
    let cookieProducts = GetCookie('wll_compare_products').split(',');
    let tableProductIds = [...cookieProducts];
    let overflowProductIds = [];
    //if mobile and more than max products, add to overflow array
    if (MOBILE_USER && cookieProducts.length > MOBILE_MAX_PRODUCTS) {
      //create overflow array
      for (let i = MOBILE_MAX_PRODUCTS; i < tableProductIds.length; i++) {
        overflowProductIds.push(tableProductIds[i]);
      }
      //trim table array
      let j = tableProductIds.length;
      while (j--) {
        if (j >= MOBILE_MAX_PRODUCTS) {
          tableProductIds.splice(j, 1);
        }
      }
    }
    //show recommended products if desktop
    if (MOBILE_USER === false) {
      showRecommendedProductBtn();
    }
    //send request
    if (!!cookieProducts.length) getComparisonProducts(cookieProducts, tableProductIds, overflowProductIds);
  } else {
    $('#compareshare__container').remove();
  }
});

/***************************/
/** RECOMMENDED PRODUCTS **/
/***************************/

/* Send POST request for recommended products */
function showRecommendedProducts() {
  //show and hide buttons
  $('#comparerecommended__btn-show').hide();
  //display container
  $('#comparerecommended__container').show();

  //check if a request has never been sent
  if (RECOMMENDED_PRODUCT_IDS.length === 0) {
    //get types and prices of table products
    let recommendedObj = {
      types: [],
      prices: [],
      returnCount: 5,
      exclusions: getRecommendedAndTableProductIds(),
    };
    for (let prod of TABLE_PRODUCTS) {
      recommendedObj.types.push(prod['Product Type']);
      recommendedObj.prices.push(prod['Algolia Price']);
    }
    //create request
    let xhr = new XMLHttpRequest();
    xhr.open('POST', ORACLE_BASE_URL + '/compare/recommended-products', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    xhr.onreadystatechange = function () {
      if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
        //Request finished
        let recommendedData = JSON.parse(this.response);
        if (recommendedData.status === 'success') {
          if (!!recommendedData.recommendedProducts.length) {
            generateRecommendedProductList(recommendedData.recommendedProducts);
          } else {
            $('#comparerecommended__products').html(RECOMMENDED_ERROR_MSG);
          }
        }
      }
    };
    xhr.send(JSON.stringify(recommendedObj));
  }
} //end showRecommendedProducts()

/* Hide recommended products */
function hideRecommendedProducts(hideAll) {
  if (hideAll) {
    $('#comparerecommended__btn-show').hide();
  } else {
    $('#comparerecommended__btn-show').show();
  }
  $('#comparerecommended__container').hide();
}

/* Append Recommended Products to Table */
function generateRecommendedProductList(recommendedProducts) {
  //loop thru recommendedProducts
  for (let product of recommendedProducts) {
    //add product id to RECOMMENDED_PRODUCT_IDS
    RECOMMENDED_PRODUCT_IDS.push(product.Id);
    //create container
    let $container = $('<div>', {
      class: 'comparerecommended__product-container',
      id: 'comparerecommended__' + product.Id,
    }).attr('data-id', product.Id);
    //add image
    let $imgContainer = $('<div>', { class: 'comparerecommended__image-container' });
    $('<img />', {
      class: 'comparerecommended__image',
      src: product.Image,
      onclick: 'appendRecommendedProductToTable(' + JSON.stringify(product) + ')',
    }).appendTo($imgContainer);
    $imgContainer.appendTo($container);
    //add name
    $('<div>', {
      class: 'comparerecommended__name',
      text: product.Name,
    }).appendTo($container);
    //add btn
    let $reccommendedBtn = $('<button>', {
      class: 'ghost-button comparerecommended__selection-btn',
      text: 'Compare',
      onclick: 'appendRecommendedProductToTable(' + JSON.stringify(product) + ')',
    });
    //disbale btn if table products at maximum
    if (TABLE_PRODUCTS.length === 5) {
      $reccommendedBtn.addClass('comparerecommended__selection-btn-disabled');
      $reccommendedBtn.prop('disabled', true);
    }
    $reccommendedBtn.appendTo($container);
    //add to parent container
    $container.appendTo($('#comparerecommended__products'));
  } //end for loop
} //end generateRecommendedProductList()

/* Append Recommended Products to Table */
function appendRecommendedProductToTable(recommendedProduct) {
  //make sure not over max of 5 and product does not already exist in array
  if (TABLE_PRODUCTS.length <= 4 && TABLE_PRODUCTS.filter((prod) => prod.Id === recommendedProduct.Id).length === 0) {
    //hide share link
    hideComparisonShare();
    //add to cookie & TABLE_PRODUCTS
    addRecommendedProductToCookie(recommendedProduct);
    //hide placeholder
    displayPlaceholderColumn(false);
    //append product to table
    let product = recommendedProduct;
    let headerTH = document.createElement('th');
    headerTH.setAttribute('id', product.Id);
    headerTH.setAttribute('class', 'comparetable__headerth comparetable__recommended ' + product.Id + '__cell');
    //add remove btn
    let removeBtn = document.createElement('div');
    removeBtn.setAttribute('class', 'comparetable__remove');
    removeBtn.setAttribute('onclick', 'removeCompareTableProduct(' + product.Id + ')');
    let removeBtnSpan = document.createElement('span');
    removeBtnSpan.appendChild(document.createTextNode('x'));
    removeBtn.appendChild(removeBtnSpan);
    headerTH.appendChild(removeBtn);
    //add image
    let imgContainer = document.createElement('div');
    imgContainer.setAttribute('class', 'comparetable__imagecontainer');
    let img = document.createElement('img');
    img.setAttribute('class', 'comparetable__image');
    img.src = product.Image;
    let imageLink = document.createElement('a');
    imageLink.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
    imageLink.appendChild(img);
    imgContainer.appendChild(imageLink);
    headerTH.appendChild(imgContainer);
    //add product link button
    let productButton = document.createElement('a');
    productButton.setAttribute('class', 'comparetable__productlinkbtn');
    productButton.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
    productButton.appendChild(document.createTextNode('View Product'));
    headerTH.appendChild(productButton);
    let productPrice = document.createElement('div'); //add product price
    productPrice.setAttribute('class', 'comparetable__price');
    productPrice.appendChild(document.createTextNode(product.Price));
    headerTH.appendChild(productPrice);
    let productLink = document.createElement('a'); //add product name/link
    productLink.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
    productLink.setAttribute('class', 'comparetable__productlink');
    productLink.appendChild(document.createTextNode(product.Name));
    headerTH.appendChild(productLink);
    //add th to tr
    $('#comparetable__thead').find('#placeholder').before(headerTH);

    //swap data cells in each data row
    $('#comparetable__tbody .comparetable__datatr').each(function (index, value) {
      let $row = $(this);
      if (!!$row.attr('data-attribute')) {
        //get attribute name
        let attrName = $row.attr('data-attribute');
        //get previous cell
        $oldCell = $row.find('td').last();
        //create new cell
        let productTD = document.createElement('td');
        productTD.setAttribute('class', product.Id + '__cell');
        productTD.setAttribute('id', product.Id + '__' + attrName);
        //check if attribute is reviews
        if (attrName === 'Reviews') {
          let reviewContainerDIV = document.createElement('div');
          reviewContainerDIV.setAttribute('class', 'comparetable__yotpocontainer');
          //check if product has reviews
          if (!!product['Review Count']) {
            let reviewDIV = document.createElement('div');
            reviewDIV.setAttribute('class', 'yotpo bottomLine');
            reviewDIV.setAttribute('data-product-id', product.Id);
            reviewContainerDIV.appendChild(reviewDIV);
          } else {
            //create empty stars
            let reviewDIV = document.createElement('div');
            reviewDIV.setAttribute('class', 'yotpo bottomLine');
            let emptyYotpoStars = document
              .createRange()
              .createContextualFragment(
                '<div class="yotpo bottomline"><div class="yotpo-bottomline pull-left star-clickable"><span class="yotpo-stars"><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span> <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span></span><a class="text-m">0 Reviews</a><div class="yotpo-clr"></div></div></div>'
              );
            reviewContainerDIV.appendChild(emptyYotpoStars);
          }
          //add review stars to table cell
          productTD.appendChild(reviewContainerDIV);
        } else {
          //all other attributes
          //check if property exists
          if (!!product[attrName]) {
            let productData = product[attrName];
            if (!!$row.attr('data-type') && ($row.attr('data-type') === 'multiple' || $row.attr('data-type') === 'list')) {
              let productDataList = productData.split(',');
              let ul = document.createElement('ul');
              ul.setAttribute('class', 'comparetable__datalist');
              for (let item of productDataList) {
                let li = document.createElement('li');
                li.appendChild(document.createTextNode(item));
                ul.appendChild(li);
              }
              productTD.appendChild(ul);
            } else if (!!$row.attr('data-type') && $row.attr('data-type') === 'decimal') {
              //regex out all chars except (, . 0-9)
              if (!!$row.attr('data-unit') && !NULL_DATA.includes(productData)) {
                productData = productData.replace(/[^0-9.,]+/g, '') + ' ' + $row.attr('data-unit');
              }
              productTD.appendChild(document.createTextNode(productData));
            } else if (!!$row.attr('data-type') && $row.attr('data-type') === 'integer') {
              //regex out all chars except (, 0-9)
              if (!!$row.attr('data-unit') && !NULL_DATA.includes(productData)) {
                productData = productData.replace(/[^0-9,]+/g, '') + ' ' + $row.attr('data-unit');
              }
              productTD.appendChild(document.createTextNode(productData));
            } else {
              //simple data type
              if (!!$row.attr('data-unit') && !NULL_DATA.includes(productData)) {
                //append data unit
                productData = productData + ' ' + $row.attr('data-unit');
              }
              productTD.appendChild(document.createTextNode(productData));
            }
          } else {
            productTD.appendChild(document.createTextNode('—'));
          }
        }
        //append new cell after previous cell
        $oldCell.after(productTD);
      }
    });
    //adjust colspan of mobile headers
    let colspan = TABLE_PRODUCTS.length !== 1 ? TABLE_PRODUCTS.length : 2;
    $('.comparetable__labeltd').attr('colspan', colspan);
    $('.comparetable__grouptd').attr('colspan', colspan);
    //refresh yotpo widget
    refreshYotpoWidgets();
    //trigger fetching of a new product
    getNewRecommendedProduct(recommendedProduct.Id);
  } //end if
} //end appendRecommendedProductToTable()

/* Add single product to recommendations */
function getNewRecommendedProduct(prevRecommendedProductId) {
  //get types and prices of table products
  let recommendedObj = {
    types: [],
    prices: [],
    returnCount: 1,
    exclusions: getRecommendedAndTableProductIds(),
  };
  for (let prod of TABLE_PRODUCTS) {
    recommendedObj.types.push(prod['Product Type']);
    recommendedObj.prices.push(prod['Algolia Price']);
  }
  //create request
  let xhr = new XMLHttpRequest();
  xhr.open('POST', ORACLE_BASE_URL + '/compare/recommended-products', true);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
  xhr.onreadystatechange = function () {
    if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
      //Request finished
      let recommendedData = JSON.parse(this.response);
      if (recommendedData.status === 'success') {
        if (!!recommendedData.recommendedProducts) {
          //remove old recommended product
          $('#comparerecommended__' + prevRecommendedProductId).remove();
          //add new recommended product
          if (!!recommendedData.recommendedProducts.length) {
            generateRecommendedProductList(recommendedData.recommendedProducts);
          }
          //show empty msg
          else if ($('.comparerecommended__product-container').length === 0) {
            $('#comparerecommended__products').html(RECOMMENDED_ERROR_MSG);
          }
        }
      }
    }
  };
  xhr.send(JSON.stringify(recommendedObj));
}

/* Add Recommended Products to Cookie */
function addRecommendedProductToCookie(recommendedProduct) {
  //add product to TABLE_PRODUCTS
  TABLE_PRODUCTS.push(recommendedProduct);
  //update cookie
  let cookieIds = [];
  for (let prod of TABLE_PRODUCTS) {
    cookieIds.push(prod.Id);
  }
  let expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 7);
  SetCookie(COMPARE_COOKIE, cookieIds.toString(), expirationDate, '/');
} //end addRecommendedProductToCookie()

/* Show Recommended Section */
function showRecommendedProductBtn() {
  $('#comparerecommended__btncontainer').show();
}

/* Get current table and recommended product IDs */
function getRecommendedAndTableProductIds() {
  let ids = [];
  for (let id of RECOMMENDED_PRODUCT_IDS) {
    ids.push(id);
  }
  for (let prod of TABLE_PRODUCTS) {
    let id = prod.Id;
    if (!ids.includes(id)) {
      ids.push(id);
    }
  }
  return ids;
}

/***********************/
/** OVERFLOW PRODUCTS **/
/***********************/

/* Populate overflow modal and display choices */
function createOverflowModal(columnToSwap) {
  //add overflow products to modal html
  $('#compareoverflow__content-products').empty();
  if (OVERFLOW_PRODUCTS.length > 0) {
    for (let product of OVERFLOW_PRODUCTS) {
      let $container = $('<div>', {
        class: 'compareoverflow__content-container',
      });
      $('<img />', {
        class: 'compareoverflow__image',
        src: product.Image,
        onclick: 'swapOverflowProduct(' + columnToSwap + ',' + product.Id + ')', //images have onclick function to replace table data
      }).appendTo($container);
      $('<div>', {
        class: 'compareoverflow__name',
        text: product.Name,
        onclick: 'swapOverflowProduct(' + columnToSwap + ',' + product.Id + ')',
      }).appendTo($container);
      $container.appendTo('#compareoverflow__content-products');
    }
  } else {
    $('#compareoverflow__content-products').append('<h4>All products visible in table.</h4>');
  }
  //show modal
  $('#compareoverflow__modal').show();
} //end createOverflowModal()

/* Swap Overflow Product Data into Table */
function swapOverflowProduct(columnToSwap, overflowProductId) {
  //columnToSwap === 0 or 1

  //get table header using columnToSwap
  $headerToBeReplaced = $('#comparetable__thead').find('th')[columnToSwap];

  //get product id that is being removed from table
  let tableProductId = $headerToBeReplaced.id;

  //get overflow product object
  let product = OVERFLOW_PRODUCTS.find((prod) => prod.Id === overflowProductId.toString());

  //add new header cell
  let headerTH = document.createElement('th');
  headerTH.setAttribute('id', product.Id);
  headerTH.setAttribute('class', 'comparetable__headerth ' + product.Id + '__cell');
  let removeBtn = document.createElement('div'); //add remove btn
  removeBtn.setAttribute('class', 'comparetable__remove');
  removeBtn.setAttribute('onclick', 'removeCompareTableProduct(' + product.Id + ')');
  let removeBtnSpan = document.createElement('span');
  removeBtnSpan.appendChild(document.createTextNode('x'));
  removeBtn.appendChild(removeBtnSpan);
  headerTH.appendChild(removeBtn);
  let imgContainer = document.createElement('div'); //add image
  imgContainer.setAttribute('class', 'comparetable__imagecontainer');
  let img = document.createElement('img');
  img.setAttribute('class', 'comparetable__image');
  img.src = product.Image;
  let imageLink = document.createElement('a');
  imageLink.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
  imageLink.appendChild(img);
  imgContainer.appendChild(imageLink);
  headerTH.appendChild(imgContainer);
  let productButton = document.createElement('a'); //add product link button
  productButton.setAttribute('class', 'comparetable__productlinkbtn');
  productButton.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
  productButton.appendChild(document.createTextNode('View Product'));
  headerTH.appendChild(productButton);
  //add mobile change btn
  if (MOBILE_USER && OVERFLOW_PRODUCTS.length > 0) {
    headerTH.appendChild(document.createElement('br'));
    let changeBtn = document.createElement('button');
    changeBtn.setAttribute('class', 'comparetable__changebtn');
    changeBtn.setAttribute('onclick', 'createOverflowModal(' + columnToSwap + ')');
    changeBtn.appendChild(document.createTextNode('Change'));
    headerTH.appendChild(changeBtn);
  }
  let productPrice = document.createElement('div'); //add product price
  productPrice.setAttribute('class', 'comparetable__price');
  productPrice.appendChild(document.createTextNode(product.Price));
  headerTH.appendChild(productPrice);
  let productLink = document.createElement('a'); //add product name/link
  productLink.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
  productLink.setAttribute('class', 'comparetable__productlink');
  productLink.appendChild(document.createTextNode(product.Name));
  headerTH.appendChild(productLink);
  //add th to tr
  $headerToBeReplaced.after(headerTH);

  //remove old header cell
  $headerToBeReplaced.remove();

  //swap data cells in each data row
  $('#comparetable__tbody .comparetable__datatr').each(function (index, value) {
    let $row = $(this);
    if (!!$row.attr('data-attribute')) {
      //get attribute name
      let attrName = $row.attr('data-attribute');
      //get old cell
      $oldCell = $row.find('td')[columnToSwap];
      //create new cell
      let productTD = document.createElement('td');
      productTD.setAttribute('class', product.Id + '__cell');
      productTD.setAttribute('id', product.Id + '__' + attrName);
      //check if attribute is reviews
      if (attrName === 'Reviews') {
        let reviewContainerDIV = document.createElement('div');
        reviewContainerDIV.setAttribute('class', 'comparetable__yotpocontainer');
        //check if product has reviews
        if (!!product['Review Count']) {
          let reviewDIV = document.createElement('div');
          reviewDIV.setAttribute('class', 'yotpo bottomLine');
          reviewDIV.setAttribute('data-product-id', product.Id);
          reviewContainerDIV.appendChild(reviewDIV);
        } else {
          //create empty stars
          let reviewDIV = document.createElement('div');
          reviewDIV.setAttribute('class', 'yotpo bottomLine');
          let emptyYotpoStars = document
            .createRange()
            .createContextualFragment(
              '<div class="yotpo bottomline"><div class="yotpo-bottomline pull-left star-clickable"><span class="yotpo-stars"><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span> <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span></span><a class="text-m">0 Reviews</a><div class="yotpo-clr"></div></div></div>'
            );
          reviewContainerDIV.appendChild(emptyYotpoStars);
        }
        //add review stars to table cell
        productTD.appendChild(reviewContainerDIV);
      } else {
        //all other attributes
        //check if property exists
        if (!!product[attrName]) {
          let productData = product[attrName];
          if (!!$row.attr('data-type') && ($row.attr('data-type') === 'multiple' || $row.attr('data-type') === 'list')) {
            let productDataList = productData.split(',');
            let ul = document.createElement('ul');
            ul.setAttribute('class', 'comparetable__datalist');
            for (let item of productDataList) {
              let li = document.createElement('li');
              li.appendChild(document.createTextNode(item));
              ul.appendChild(li);
            }
            productTD.appendChild(ul);
          } else if (!!$row.attr('data-type') && $row.attr('data-type') === 'decimal') {
            //regex out all chars except (, . 0-9)
            if (!!$row.attr('data-unit') && !NULL_DATA.includes(productData)) {
              productData = productData.replace(/[^0-9.,]+/g, '') + ' ' + $row.attr('data-unit');
            }
            productTD.appendChild(document.createTextNode(productData));
          } else if (!!$row.attr('data-type') && $row.attr('data-type') === 'integer') {
            //regex out all chars except (, 0-9)
            if (!!$row.attr('data-unit') && !NULL_DATA.includes(productData)) {
              productData = productData.replace(/[^0-9,]+/g, '') + ' ' + $row.attr('data-unit');
            }
            productTD.appendChild(document.createTextNode(productData));
          } else {
            //simple data type
            if (!!$row.attr('data-unit') && !NULL_DATA.includes(productData)) {
              //append data unit
              productData = productData + ' ' + $row.attr('data-unit');
            }
            productTD.appendChild(document.createTextNode(productData));
          }
        } else {
          productTD.appendChild(document.createTextNode('—'));
        }
      }
      //append new cell after old cell
      $oldCell.after(productTD);
      //delete old cell
      $oldCell.remove();
    }
  });

  //move overflow product into table array
  let overflowIndex = OVERFLOW_PRODUCTS.findIndex((prod) => prod.Id === overflowProductId.toString());
  TABLE_PRODUCTS.push(OVERFLOW_PRODUCTS[overflowIndex]);
  OVERFLOW_PRODUCTS.splice(overflowIndex, 1);

  //move table product to overflow array if not placeholder
  if (tableProductId !== 'placeholder') {
    let tableIndex = TABLE_PRODUCTS.findIndex((prod) => prod.Id === tableProductId.toString());
    OVERFLOW_PRODUCTS.push(TABLE_PRODUCTS[tableIndex]);
    TABLE_PRODUCTS.splice(tableIndex, 1);
  }

  //hide share link
  hideComparisonShare();

  //close modal
  closeCompareModal();

  //refresh yotpo widget
  refreshYotpoWidgets();

  //scroll to top of window
  $('html, body').animate({ scrollTop: $('#compareshare__container').offset().top }, 'fast');
} //end swapOverflowProduct()

/* Close Compare Modal */
function closeCompareModal() {
  $('.comparemodal').hide();
}
$(window).on('click touchend', function (event) {
  //close overflow modal if modal is open
  if ($('.comparemodal').css('display') !== 'none' && event.target && event.target.className == 'comparemodal') {
    event.preventDefault();
    $('.comparemodal').hide();
  }
});

/**********************/
/** COMPARE PRODUCTS **/
/**********************/

/* Send POST request for compare data */
function getComparisonProducts(productIds, tableProductIds, overflowProductIds) {
  let xhr = new XMLHttpRequest();
  xhr.open('POST', ORACLE_BASE_URL + '/compare/compare-products', true);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
  xhr.onreadystatechange = function () {
    if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
      //Request finished
      let compareData = JSON.parse(this.response);
      if (compareData.status === 'success') {
        //mobile user with overflow?
        if (MOBILE_USER && overflowProductIds.length > 0) {
          //create mobile table using matches found in tableProductIds
          TABLE_PRODUCTS = compareData.compareProducts.filter((algoliaProduct) => tableProductIds.includes(algoliaProduct.Id));
          //create overflow array
          OVERFLOW_PRODUCTS = compareData.compareProducts.filter((algoliaProduct) => overflowProductIds.includes(algoliaProduct.Id));
          if (!!TABLE_PRODUCTS.length) {
            generateComparisonTable(compareData.attributeGroups, TABLE_PRODUCTS.length, TABLE_PRODUCTS);
          } else {
            //show error msg
            showCompareErrorMessage();
          }
        }
        //desktop user
        else {
          //use original products
          TABLE_PRODUCTS = compareData.compareProducts;
          if (!!TABLE_PRODUCTS.length) {
            generateComparisonTable(compareData.attributeGroups, compareData.productCount, compareData.compareProducts);
          } else {
            //show error msg
            showCompareErrorMessage();
          }
        }

        //init Yotpo widgets
        $(document).ready(function () {
          refreshYotpoWidgets();
        });
      } else {
        //show error msg
        showCompareErrorMessage();
      }
    }
  };
  xhr.send(JSON.stringify({ shopifyProductIds: productIds }));
}

/* Handle Returned Product Compare JSON */
function generateComparisonTable(attributeGroups, productCount, compareProducts) {
  let tableBody = document.getElementById('comparetable__tbody');
  let tableHeader = document.getElementById('comparetable__thead');

  //create header row first
  let headerTR = document.createElement('tr');
  tableHeader.appendChild(headerTR);
  let productCounter = -1;
  for (let product of compareProducts) {
    productCounter++;
    let headerTH = document.createElement('th');
    headerTH.setAttribute('id', product.Id);
    headerTH.setAttribute('class', 'comparetable__headerth ' + product.Id + '__cell');
    //add remove btn
    let removeBtn = document.createElement('div');
    removeBtn.setAttribute('class', 'comparetable__remove');
    removeBtn.setAttribute('onclick', 'removeCompareTableProduct(' + product.Id + ')');
    let removeBtnSpan = document.createElement('span');
    removeBtnSpan.appendChild(document.createTextNode('x'));
    removeBtn.appendChild(removeBtnSpan);
    headerTH.appendChild(removeBtn);
    //add image
    let imgContainer = document.createElement('div');
    imgContainer.setAttribute('class', 'comparetable__imagecontainer');
    let img = document.createElement('img');
    img.setAttribute('class', 'comparetable__image');
    img.src = product.Image;
    let imageLink = document.createElement('a');
    imageLink.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
    imageLink.appendChild(img);
    imgContainer.appendChild(imageLink);
    headerTH.appendChild(imgContainer);
    //add product link button
    let productButton = document.createElement('a');
    productButton.setAttribute('class', 'comparetable__productlinkbtn');
    productButton.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
    productButton.appendChild(document.createTextNode('View Product'));
    headerTH.appendChild(productButton);
    //add mobile change btn
    if (MOBILE_USER && OVERFLOW_PRODUCTS.length > 0) {
      headerTH.appendChild(document.createElement('br'));
      let changeBtn = document.createElement('button');
      changeBtn.setAttribute('class', 'comparetable__changebtn');
      changeBtn.setAttribute('onclick', 'createOverflowModal(' + productCounter + ')');
      changeBtn.appendChild(document.createTextNode('Change'));
      headerTH.appendChild(changeBtn);
    }
    //add product price
    let productPrice = document.createElement('div');
    productPrice.setAttribute('class', 'comparetable__price');
    productPrice.appendChild(document.createTextNode(product.Price));
    headerTH.appendChild(productPrice);
    //add product name/link
    let productLink = document.createElement('a');
    productLink.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
    productLink.setAttribute('class', 'comparetable__productlink');
    productLink.appendChild(document.createTextNode(product.Name));
    headerTH.appendChild(productLink);
    //add th to tr
    headerTR.appendChild(headerTH);
  }

  //** product placeholder for single product **
  let placeholderImageTH = document.createElement('th');
  placeholderImageTH.setAttribute('class', 'comparetable__headerth placeholder__cell');
  placeholderImageTH.setAttribute('id', 'placeholder');
  let placeholderImgContainer = document.createElement('div');
  placeholderImgContainer.setAttribute('class', 'comparetable__imagecontainer comparetable__imagecontainer-placeholder');
  let placeholderImg = document.createElement('img');
  placeholderImg.setAttribute('class', 'comparetable__image');
  placeholderImg.src = PLACEHOLDER_IMAGE;
  placeholderImgContainer.appendChild(placeholderImg);
  placeholderImageTH.appendChild(placeholderImgContainer);
  let placeholderName = document.createElement('div');
  placeholderName.setAttribute('class', 'comparetable__name-placeholder');
  //add different action for mobile and desktop
  if (MOBILE_USER) {
    let text = document.createRange().createContextualFragment('<a href="/search" class="placeholder-action">Search for another product to compare</a>');
    placeholderName.appendChild(text);
  } else {
    let text = document
      .createRange()
      .createContextualFragment(
        '<a onclick="$(\'#comparerecommended__btn-show\').click()" class="placeholder-action">View recommendations</a> or <a href="/search" class="placeholder-action">search for another product to compare</a>'
      );
    placeholderName.appendChild(text);
  }
  placeholderImageTH.appendChild(placeholderName);
  headerTR.appendChild(placeholderImageTH);

  //loop thru group names
  for (const groupName of Object.keys(attributeGroups).sort()) {
    //create group name row
    let groupTR = document.createElement('tr');
    groupTR.setAttribute('class', 'comparetable__grouptr');
    let groupLabelTD = document.createElement('td');
    if (groupName === '1_top_group') {
      //constant top group
      groupLabelTD.appendChild(document.createTextNode('Basic Stats'));
    } else {
      //all other groups
      let groupObj = attributeGroups[groupName];
      if (!!groupObj.toolTip || !!groupObj.externalURI) {
        //tooltips or URI
        let groupDIV = document.createElement('div');
        groupDIV.setAttribute('class', 'comparetable__tooltip-container');
        let groupLabelSPAN = document.createElement('span');
        groupLabelSPAN.setAttribute('class', 'comparetable__attributename');
        groupLabelSPAN.appendChild(document.createTextNode(groupName));
        let infoIcon = document.createElement('i');
        infoIcon.setAttribute('class', 'icon-info-circle');
        groupLabelSPAN.appendChild(infoIcon);
        groupDIV.appendChild(groupLabelSPAN);
        let groupTooltipSPAN = document.createElement('span');
        groupTooltipSPAN.setAttribute('class', 'comparetable__tooltip');
        //tooltip and link
        if (!!groupObj.toolTip && !!groupObj.externalURI) {
          let tooltipText = document.createElement('span');
          tooltipText.setAttribute('class', 'comparetable__tooltip-text');
          tooltipText.appendChild(document.createTextNode(groupObj.toolTip));
          groupTooltipSPAN.appendChild(tooltipText);
          groupTooltipSPAN.appendChild(createTooltipURINode(groupObj.externalURI));
        }
        //tooltip but no link
        else if (!!groupObj.toolTip && !!groupObj.externalURI === false) {
          let tooltipText = document.createElement('span');
          tooltipText.setAttribute('class', 'comparetable__tooltip-text');
          tooltipText.appendChild(document.createTextNode(groupObj.toolTip));
          groupTooltipSPAN.appendChild(tooltipText);
        }
        //link but no toolip
        else if (!!groupObj.toolTip === false && !!groupObj.externalURI === true) {
          groupTooltipSPAN.appendChild(createTooltipURINode(groupObj.externalURI));
        }
        groupDIV.appendChild(groupTooltipSPAN);
        groupLabelTD.appendChild(groupDIV);
      } else {
        //no tooltips or URI
        groupLabelTD.appendChild(document.createTextNode(groupName));
      } //end else
    } //end else
    groupLabelTD.setAttribute('colspan', productCount === 1 ? 2 : productCount);
    groupLabelTD.setAttribute('class', 'comparetable__grouptd');
    groupTR.appendChild(groupLabelTD);
    tableBody.appendChild(groupTR);

    //loop thru attributes
    for (let attribute of attributeGroups[groupName].attributes) {
      //create header row
      let attrTR = document.createElement('tr');
      attrTR.setAttribute('class', 'comparetable__labeltr');
      let attrLabelTD = document.createElement('td');
      attrLabelTD.setAttribute('colspan', productCount === 1 ? 2 : productCount);
      attrLabelTD.setAttribute('class', 'comparetable__labeltd');
      //add attribute name and tooltip
      if (!!attribute.toolTip || !!attribute.externalURI) {
        //tooltip present
        let attrDIV = document.createElement('div');
        attrDIV.setAttribute('class', 'comparetable__tooltip-container');
        let attrLabelSPAN = document.createElement('span');
        attrLabelSPAN.setAttribute('class', 'comparetable__attributename');
        attrLabelSPAN.appendChild(document.createTextNode(attribute.name));
        let infoIcon = document.createElement('i');
        infoIcon.setAttribute('class', 'icomoon-info-circle-solid');
        attrLabelSPAN.appendChild(infoIcon);
        attrDIV.appendChild(attrLabelSPAN);
        let attrTooltipSPAN = document.createElement('span');
        attrTooltipSPAN.setAttribute('class', 'comparetable__tooltip');
        //tooltip and link
        if (!!attribute.toolTip && !!attribute.externalURI) {
          let tooltipText = document.createElement('span');
          tooltipText.setAttribute('class', 'comparetable__tooltip-text');
          tooltipText.appendChild(document.createTextNode(attribute.toolTip));
          attrTooltipSPAN.appendChild(tooltipText);
          attrTooltipSPAN.appendChild(createTooltipURINode(attribute.externalURI));
        }
        //tooltip but no link
        else if (!!attribute.toolTip && !!attribute.externalURI === false) {
          let tooltipText = document.createElement('span');
          tooltipText.setAttribute('class', 'comparetable__tooltip-text');
          tooltipText.appendChild(document.createTextNode(attribute.toolTip));
          attrTooltipSPAN.appendChild(tooltipText);
        }
        //link but no toolip
        else if (!!attribute.toolTip === false && !!attribute.externalURI === true) {
          attrTooltipSPAN.appendChild(createTooltipURINode(attribute.externalURI));
        }
        attrDIV.appendChild(attrTooltipSPAN);
        attrLabelTD.appendChild(attrDIV);
      } else {
        //no tooltip
        attrLabelTD.appendChild(document.createTextNode(attribute.name));
      }
      //add table cell -> row -> table
      attrTR.appendChild(attrLabelTD);
      tableBody.appendChild(attrTR);
      //create data row
      let dataTR = document.createElement('tr');
      dataTR.setAttribute('class', 'comparetable__datatr');
      dataTR.setAttribute('data-attribute', attribute.name);
      if (!!attribute.dataUnit) dataTR.setAttribute('data-unit', attribute.dataUnit);
      if (!!attribute.dataType) dataTR.setAttribute('data-type', attribute.dataType);
      tableBody.appendChild(dataTR);
      //create data cells
      for (let product of compareProducts) {
        let productTD = document.createElement('td');
        productTD.setAttribute('class', product.Id + '__cell');
        productTD.setAttribute('id', product.Id + '__' + attribute.name);
        //check if attribute is reviews
        if (attribute.name === 'Reviews') {
          let reviewContainerDIV = document.createElement('div');
          reviewContainerDIV.setAttribute('class', 'comparetable__yotpocontainer');
          //check if product has reviews
          if (!!product['Review Count']) {
            let reviewDIV = document.createElement('div');
            reviewDIV.setAttribute('class', 'yotpo bottomLine');
            reviewDIV.setAttribute('data-product-id', product.Id);
            reviewContainerDIV.appendChild(reviewDIV);
          } else {
            //create empty stars
            let reviewDIV = document.createElement('div');
            reviewDIV.setAttribute('class', 'yotpo bottomLine');
            let emptyYotpoStars = document
              .createRange()
              .createContextualFragment(
                '<div class="yotpo bottomline"><div class="yotpo-bottomline pull-left star-clickable"><span class="yotpo-stars"><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span> <span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span><span class="yotpo-icon yotpo-icon-empty-star pull-left"></span></span><a class="text-m">0 Reviews</a><div class="yotpo-clr"></div></div></div>'
              );
            reviewContainerDIV.appendChild(emptyYotpoStars);
          }
          //add review stars to table cell
          productTD.appendChild(reviewContainerDIV);
        } else {
          //all other attributes
          //check if property exists
          if (!!product[attribute.name]) {
            let productData = product[attribute.name];
            //check if dataType is multiple and create unordered list
            if (!!attribute.dataType && (attribute.dataType === 'multiple' || attribute.dataType === 'list')) {
              let productDataList = productData.split(',');
              let ul = document.createElement('ul');
              ul.setAttribute('class', 'comparetable__datalist');
              for (let item of productDataList) {
                let li = document.createElement('li');
                item = item.replace(/&quot;/g, "'");
                li.appendChild(document.createTextNode(item));
                ul.appendChild(li);
              }
              productTD.appendChild(ul);
            } else if (!!attribute.dataType && attribute.dataType === 'decimal') {
              //regex out all chars except (, . 0-9)
              if (!!attribute.dataUnit && !NULL_DATA.includes(productData)) {
                productData = productData.replace(/[^0-9.,]+/g, '') + ' ' + attribute.dataUnit;
              }
              productTD.appendChild(document.createTextNode(productData));
            } else if (!!attribute.dataType && attribute.dataType === 'integer') {
              //regex out all chars except (, 0-9)
              if (!!attribute.dataUnit && !NULL_DATA.includes(productData)) {
                productData = productData.replace(/[^0-9,]+/g, '') + ' ' + attribute.dataUnit;
              }
              productTD.appendChild(document.createTextNode(productData));
            } else {
              //simple data type
              if (!!attribute.dataUnit && !NULL_DATA.includes(productData)) {
                //append data unit
                productData = productData + ' ' + attribute.dataUnit;
              }
              productTD.appendChild(document.createTextNode(productData));
            }
          } //end prop exists if
          else {
            productTD.appendChild(document.createTextNode('—'));
          }
        }
        //append table cell to row
        dataTR.appendChild(productTD);
      } //end product loop
      //** product placeholder for single product **
      let placeholderTD = document.createElement('td');
      placeholderTD.setAttribute('class', 'placeholder__cell');
      placeholderTD.appendChild(document.createTextNode('—'));
      dataTR.appendChild(placeholderTD);
    } //end attr name loop
  } //end group name loop
  //if mobile and overflow products exist, add buttons
  if (MOBILE_USER && OVERFLOW_PRODUCTS.length > 0) {
    let changeTR = document.createElement('tr');
    changeTR.setAttribute('class', 'comparetable__datatr comparetable__changetr');
    tableBody.appendChild(changeTR);
    let changeTD1 = document.createElement('td');
    let changeBtn1 = document.createElement('button');
    changeBtn1.setAttribute('class', 'alt-button');
    changeBtn1.setAttribute('onclick', 'createOverflowModal(0)');
    changeBtn1.appendChild(document.createTextNode('Change'));
    changeTD1.appendChild(changeBtn1);
    changeTR.appendChild(changeTD1);
    let changeTD2 = document.createElement('td');
    let changeBtn2 = document.createElement('button');
    changeBtn2.setAttribute('class', 'alt-button');
    changeBtn2.setAttribute('onclick', 'createOverflowModal(1)');
    changeBtn2.appendChild(document.createTextNode('Change'));
    changeTD2.appendChild(changeBtn2);
    changeTR.appendChild(changeTD2);
  }
  //show or hide placeholder column
  if (productCount > 1) {
    displayPlaceholderColumn(false);
  }
  //start scroll effect
  createCompareTableScroll();
} //end generateComparisonTable()

/* Create scrolling/shrinkage effect */
function createCompareTableScroll() {
  // Get the real width of the logo image
  let imgWidth = $('.comparetable__image').first().width();
  //get initial height of img container
  let imgContainerHeight = 220;
  // distance over which zoom effect takes place
  let maxScrollDistance = 100;
  // set to window height if larger
  maxScrollDistance = Math.min(maxScrollDistance, $(window).height());
  // width at maximum zoom out (i.e. when window has scrolled maxScrollDistance)
  let imgWidthAtMax = 100;
  // calculate diff and how many pixels to zoom per pixel scrolled
  let imgWidthDiff = imgWidth - imgWidthAtMax;
  let pixelsPerScroll = imgWidthDiff / maxScrollDistance;
  // get the height of product name
  let productNameHeight = 0;
  $('.comparetable__productlink').each(function () {
    productNameHeight = productNameHeight > $(this).height() ? productNameHeight : $(this).height();
  });
  //get height of product link button
  let productLinkBtnHeight = $('.comparetable__productlinkbtn').first().height();
  //get margin of product name link
  let productNameMargin = parseInt($('.comparetable__productlink').css('margin-top'), 10);
  //get margin of product name
  let productLinkBtnMargin = parseInt($('.comparetable__productlinkbtn').css('margin-top'), 10);
  //get margin of product price
  let productPriceMargin = parseInt($('.comparetable__price').css('margin-top'), 10);
  //get padding top of first gorup header
  let firstGroupPaddingTop = parseInt($('.comparetable__grouptd').first().css('padding-top'), 10);
  $(window).scroll(function () {
    let tableOffset = $('#comparetable__thead').offset().top;
    if ($(document).scrollTop() > tableOffset) {
      // the currently scrolled-to position - max-out at maxScrollDistance
      let scrollTopPos = Math.min($(document).scrollTop() - tableOffset, maxScrollDistance);
      // how many pixels to adjust by
      let scrollChangePx = Math.floor(scrollTopPos * pixelsPerScroll);
      // calculate the new width
      let zoomedWidth = imgWidth - scrollChangePx;
      // set the img width
      $('.comparetable__image').css('width', zoomedWidth);
      // set the img height
      $('.comparetable__imagecontainer').css('height', zoomedWidth);
      //change margin of product name
      let productNameMarginChanged = productNameMargin - scrollChangePx;
      if (productNameMarginChanged <= 0) {
        productNameMarginChanged = 0;
      }
      $('.comparetable__productlink').css('margin-top', productNameMarginChanged + 'px');
      $('.comparetable__productlink').css('margin-bottom', productNameMarginChanged + 'px');
      // change height of product name
      let productNameHeightChanged;
      if (MOBILE_USER) {
        productNameHeightChanged = productNameHeight - (scrollChangePx + scrollChangePx * 2);
      } else {
        productNameHeightChanged = productNameHeight - scrollChangePx / 2;
      }
      if (productNameHeightChanged <= 24) {
        productNameHeightChanged = 24;
      }
      $('.comparetable__productlink').css('height', productNameHeightChanged);
      $('.comparetable__name-placeholder').css('height', productNameHeightChanged);
      //change margin product link button
      let productLinkBtnMarginChanged;
      if (MOBILE_USER) {
        productLinkBtnMarginChanged = productLinkBtnMargin - scrollChangePx;
      } else {
        productLinkBtnMarginChanged = productLinkBtnMargin - scrollChangePx / 2;
      }
      if (productLinkBtnMarginChanged <= 0) {
        productLinkBtnMarginChanged = 0;
      }
      $('.comparetable__productlinkbtn').css('margin-top', productLinkBtnMarginChanged + 'px');
      $('.comparetable__changebtn').css('margin-top', productLinkBtnMarginChanged + 'px');
      //change height product link button
      let productLinkBtnHeightChanged;
      if (MOBILE_USER) {
        productLinkBtnHeightChanged = productLinkBtnHeight - scrollChangePx;
      } else {
        productLinkBtnHeightChanged = productLinkBtnHeight - scrollChangePx / 2;
      }
      $('.comparetable__productlinkbtn').css('height', productLinkBtnHeightChanged);
      $('.comparetable__changebtn').css('height', productLinkBtnHeightChanged);
      if (productLinkBtnHeightChanged <= 0) {
        productLinkBtnHeightChanged = 0;
        $('.comparetable__productlinkbtn').css('border-width', '0px');
        $('.comparetable__productlinkbtn').css('display', 'none');
        $('.comparetable__changebtn').css('border-width', '0px');
        $('.comparetable__changebtn').css('display', 'none');
      } else {
        $('.comparetable__productlinkbtn').css('display', 'inline-block');
        $('.comparetable__changebtn').css('display', 'inline-block');
      }
      //change margin on product price
      let productPriceMarginChanged = productPriceMargin - scrollChangePx / 2;
      if (productPriceMarginChanged <= 0) {
        productPriceMarginChanged = 0;
      }
      $('.comparetable__price').css('margin-top', productPriceMarginChanged + 'px');
      //change padding of top group heading row
      if (zoomedWidth >= imgWidthAtMax) {
        if (MOBILE_USER && $(window).width() <= 480) {
          padding = firstGroupPaddingTop + (scrollChangePx + scrollChangePx);
        } else {
          padding = firstGroupPaddingTop + scrollChangePx;
        }
        $('.comparetable__grouptd')[0].style.setProperty('padding-top', padding + 'px', 'important');
      }
    } else {
      //reset components
      $('.comparetable__image').css('width', imgWidth);
      $('.comparetable__imagecontainer').css('height', imgContainerHeight);
      $('.comparetable__productlink').css('height', 'auto');
      $('.comparetable__name-placeholder').css('height', 'auto');
      $('.comparetable__productlinkbtn').css('height', 'auto');
      $('.comparetable__productlinkbtn').css('border-width', '1px');
      $('.comparetable__productlinkbtn').css('display', 'inline-block');
      $('.comparetable__changebtn').css('height', '27px');
      $('.comparetable__changebtn').css('border-width', '1px');
      $('.comparetable__changebtn').css('display', 'inline-block');
      $('.comparetable__productlink').css('margin-top', productNameMargin + 'px');
      $('.comparetable__productlink').css('margin-bottom', productNameMargin + 'px');
      $('.comparetable__productlinkbtn').css('margin-top', productLinkBtnMargin + 'px');
      $('.comparetable__changebtn').css('margin-top', productLinkBtnMargin + 'px');
      $('.comparetable__price').css('margin-top', productPriceMargin + 'px');
      $('.comparetable__grouptd')[0].style.setProperty('padding-top', firstGroupPaddingTop + 'px', 'important');
    }
  });
}

/* Delete product from comparison */
function removeCompareTableProduct(productId) {
  //find product id within TABLE_PRODUCTS
  let index = TABLE_PRODUCTS.findIndex((prod) => prod.Id.toString() === productId.toString());
  if (index !== -1) {
    //remove index from table products
    TABLE_PRODUCTS.splice(index, 1);
    //reset cookie without product id
    let cookieIds = [];
    for (let tprod of TABLE_PRODUCTS) {
      cookieIds.push(tprod.Id);
    }
    for (let oprod of OVERFLOW_PRODUCTS) {
      cookieIds.push(oprod.Id);
    }
    let expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 7);
    SetCookie(COMPARE_COOKIE, cookieIds.toString(), expirationDate, '/');
    //hide share link
    hideComparisonShare();
    //remove table cells
    let productCells = document.getElementsByClassName(productId.toString() + '__cell');
    while (productCells.length > 0) {
      productCells[0].remove();
    }

    //is user on mobile with overflow products?
    if (MOBILE_USER && OVERFLOW_PRODUCTS.length > 0) {
      //get first index of overflow products
      let product = OVERFLOW_PRODUCTS[0];
      //add new header cell
      let headerTH = document.createElement('th');
      headerTH.setAttribute('id', product.Id);
      headerTH.setAttribute('class', 'comparetable__headerth ' + product.Id + '__cell');
      let removeBtn = document.createElement('div'); //add remove btn
      removeBtn.setAttribute('class', 'comparetable__remove');
      removeBtn.setAttribute('onclick', 'removeCompareTableProduct(' + product.Id + ')');
      let removeBtnSpan = document.createElement('span');
      removeBtnSpan.appendChild(document.createTextNode('x'));
      removeBtn.appendChild(removeBtnSpan);
      headerTH.appendChild(removeBtn);
      let imgContainer = document.createElement('div'); //add image
      imgContainer.setAttribute('class', 'comparetable__imagecontainer');
      let img = document.createElement('img');
      img.setAttribute('class', 'comparetable__image');
      img.src = product.Image;
      let imageLink = document.createElement('a');
      imageLink.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
      imageLink.appendChild(img);
      imgContainer.appendChild(imageLink);
      headerTH.appendChild(imgContainer);
      let productButton = document.createElement('a'); //add product link button
      productButton.setAttribute('class', 'comparetable__productlinkbtn');
      productButton.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
      productButton.appendChild(document.createTextNode('View Product'));
      headerTH.appendChild(productButton);
      headerTH.appendChild(document.createElement('br'));
      let changeBtn = document.createElement('button'); //add change btn
      changeBtn.setAttribute('class', 'comparetable__changebtn');
      changeBtn.setAttribute('onclick', 'createOverflowModal(1)');
      changeBtn.appendChild(document.createTextNode('Change'));
      headerTH.appendChild(changeBtn);
      let productPrice = document.createElement('div'); //add product price
      productPrice.setAttribute('class', 'comparetable__price');
      productPrice.appendChild(document.createTextNode(product.Price));
      headerTH.appendChild(productPrice);
      let productLink = document.createElement('a'); //add product name/link
      productLink.setAttribute('href', BASE_STORE_URL + '/products/' + product.Handle);
      productLink.setAttribute('class', 'comparetable__productlink');
      productLink.appendChild(document.createTextNode(product.Name));
      headerTH.appendChild(productLink);
      //add th to tr
      $('#comparetable__thead').find('th')[0].after(headerTH);
      //swap data cells in each data row
      $('#comparetable__tbody .comparetable__datatr').each(function (index, value) {
        let $row = $(this);
        if (!!$row.attr('data-attribute')) {
          //get row name
          let attrName = $row.attr('data-attribute');
          //create new cell
          let productTD = document.createElement('td');
          productTD.setAttribute('class', product.Id + '__cell');
          productTD.setAttribute('id', product.Id + '__' + attrName);
          //check if property exists
          if (!!product[attrName]) {
            let productData = product[attrName];
            if (!!$row.attr('data-type') && ($row.attr('data-type') === 'multiple' || $row.attr('data-type') === 'list')) {
              let productDataList = productData.split(',');
              let ul = document.createElement('ul');
              ul.setAttribute('class', 'comparetable__datalist');
              for (let item of productDataList) {
                let li = document.createElement('li');
                li.appendChild(document.createTextNode(item));
                ul.appendChild(li);
              }
              productTD.appendChild(ul);
            } else if (!!$row.attr('data-type') && $row.attr('data-type') === 'decimal') {
              //regex out all chars except (, . 0-9)
              if (!!$row.attr('data-unit') && !NULL_DATA.includes(productData)) {
                productData = productData.replace(/[^0-9.,]+/g, '') + ' ' + $row.attr('data-unit');
              }
              productTD.appendChild(document.createTextNode(productData));
            } else if (!!$row.attr('data-type') && $row.attr('data-type') === 'integer') {
              //regex out all chars except (, 0-9)
              if (!!$row.attr('data-unit') && !NULL_DATA.includes(productData)) {
                productData = productData.replace(/[^0-9,]+/g, '') + ' ' + $row.attr('data-unit');
              }
              productTD.appendChild(document.createTextNode(productData));
            } else {
              //simple data type
              if (!!$row.attr('data-unit') && !NULL_DATA.includes(productData)) {
                //append data unit
                productData = productData + ' ' + $row.attr('data-unit');
              }
              productTD.appendChild(document.createTextNode(productData));
            }
          } else {
            productTD.appendChild(document.createTextNode('—'));
          }
          //append new cell after old cell
          $row.find('td')[0].after(productTD);
        }
      });
      //move overflow product into table products array
      TABLE_PRODUCTS.push(product);
      OVERFLOW_PRODUCTS.splice(0, 1);
      //scroll to top of window
      $('html, body').animate({ scrollTop: $('#compareshare__container').offset().top }, 'fast');
    } else {
      //desktop user - OR -  mobile user with no overflow products
      //adjust colspan of table headers
      let colspan = TABLE_PRODUCTS.length !== 1 ? TABLE_PRODUCTS.length : 2;
      $('.comparetable__labeltd').attr('colspan', colspan);
      $('.comparetable__grouptd').attr('colspan', colspan);
      //show placeholder column if one product left
      if (TABLE_PRODUCTS.length === 1) {
        displayPlaceholderColumn(true);
      }
      //are all table products removed??
      else if (TABLE_PRODUCTS.length === 0) {
        $('#comparetable__thead').html('');
        $('#comparetable__tbody').html('');
        $('#compareshare__container').remove();
        //hide recommended
        hideRecommendedProducts(true);
      }
    } //end desktop/mobile else
  }
} //end removeCompareTableProduct()

/* Show/Hide Placeholder Column */
function displayPlaceholderColumn(display) {
  let cells = document.getElementsByClassName('placeholder__cell');
  for (let i = 0; i < cells.length; i++) {
    if (display) {
      cells[i].style.display = 'table-cell';
    } else {
      cells[i].style.display = 'none';
    }
  }
}

/* Show Error Message for Service Failure */
function showCompareErrorMessage() {
  $('#compareintro').before('<h4 style="color:red;">We are sorry but we are experiencing an error with the product comparison. Please try again later.</h4>');
  $('#compareintro').remove();
  $('#compareinstructions').remove();
}

/********************/
/** COMPARISON URL **/
/********************/

/* Base64 Encode Product Ids */
function encodeCompareURL(productIds) {
  let base64String = btoa(productIds);
  base64String = base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
  return base64String;
}

/* Create Comparison Link */
function createCompareShareLink() {
  let ids = [];
  for (let tprod of TABLE_PRODUCTS) {
    ids.push(tprod.Id);
  }
  for (let oprod of OVERFLOW_PRODUCTS) {
    ids.push(oprod.Id);
  }
  let link = BASE_STORE_URL + '/pages/compare?products=' + encodeCompareURL(ids.toString());
  document.getElementById('compareshare__input').value = link;
  //show input and copy btn
  document.getElementById('compareshare__linkcontainer').style.display = 'flex';
}

/* Update Window URL */
function updateCompareWindowURL() {
  let ids = [];
  for (let tprod of TABLE_PRODUCTS) {
    ids.push(tprod.Id);
  }
  for (let oprod of OVERFLOW_PRODUCTS) {
    ids.push(oprod.Id);
  }
  let url = '/pages/compare?products=' + encodeCompareURL(ids.toString());
  window.history.pushState('', '', url);
}

/* Copy Share Link */
function copyCompareShareLink() {
  let $input = $('#compareshare__input');
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    let el = $input.get(0);
    let editable = el.contentEditable;
    let readOnly = el.readOnly;
    el.contentEditable = true;
    el.readOnly = true;
    let range = document.createRange();
    range.selectNodeContents(el);
    let sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    el.setSelectionRange(0, 999999);
    el.contentEditable = editable;
    el.readOnly = readOnly;
  } else {
    $input.select();
  }
  document.execCommand('copy');
  $input.blur();
  $('#compareshare__copybtn')
    .html("Copied&nbsp;<span class='icon-check'></span>")
    .animate({ opacity: 1 }, 2000, function () {
      $(this).html('Copy Link');
    });
}

/* Hide Share Input and Copy Button */
function hideComparisonShare() {
  $('#compareshare__linkcontainer').hide();
  $('#compareshare__copybtn').text('Copy Link');
}

/**************/
/** TOOLTIPS **/
/**************/

/* Generate tool tip link */
function createTooltipURINode(uri) {
  let link = document.createElement('a');
  link.setAttribute('class', 'comparetable__tooltip-link');
  link.setAttribute('href', uri);
  link.setAttribute('target', '_blank');
  let linkText = '';
  if (/http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/.test(uri)) {
    linkText = 'Watch Video';
  } else if (uri.includes('wiki.wholelattelove')) {
    linkText = 'Learn More';
  } else {
    linkText = 'Read More';
  }
  link.appendChild(document.createTextNode(linkText));
  //add caret icon
  let icon = document.createElement('i');
  icon.setAttribute('class', 'toggle-play-icon');
  link.appendChild(icon);
  return link;
}

/* Show/Hide attribute tooltips */
$(document).on('click touchend', '.comparetable__attributename', function (event) {
  event.preventDefault();
  let $tooltip = $(this).next('.comparetable__tooltip');
  if ($tooltip.is(':visible') === false) {
    $tooltip.show();
    $('.comparetable__tooltip').not($tooltip).hide();
  } else {
    $('.comparetable__tooltip').hide();
  }
});

/********************/
/** TABLE OBSERVER **/
/********************/

/* Mutation Observer to change Compare Product Count */
let compareTableTarget = document.getElementById('comparetable__thead');
if (!!compareTableTarget) {
  let config = { attributes: true, childList: true, subtree: true };
  let callback = function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type == 'childList') {
        //set count of table products
        $('#compare-counter').text(TABLE_PRODUCTS.length + OVERFLOW_PRODUCTS.length);
        //if not on mobile, control reccommended product btns
        if (!MOBILE_USER && !!$('.comparerecommended__selection-btn').length) {
          if (TABLE_PRODUCTS.length === 5) {
            //disable
            $('.comparerecommended__selection-btn').prop('disabled', true).addClass('comparerecommended__selection-btn-disabled');
          } else {
            //enable
            $('.comparerecommended__selection-btn').prop('disabled', false).removeClass('comparerecommended__selection-btn-disabled');
          }
        }
        //update url
        if (USING_URL_PARAMS) updateCompareWindowURL();
      }
    }
  };
  let observer = new MutationObserver(callback);
  observer.observe(compareTableTarget, config);
}

/********************/
/** INSTRUCTIONS **/
/********************/

/* Scroll to Instructions */
function scrollToInstructions() {
  $('html, body').animate({ scrollTop: $('#compareinstructions').offset().top - ($('.comparetable__headerth').first().height() - 198) }, 1500);
}

/* Preload Instruction GIFs */
$('.compare-instructions-gif').each(function (index) {
  let instructionGIFS = [];
  instructionGIFS[index] = new Image();
  instructionGIFS[index].src = $(this).data('altsrc');
});

/* Click to Play GIF */
$('figure').on('click', function () {
  $(this).children('i').toggle();
  let $img = $(this).children('img');
  $img.toggleClass('compare-instructions-gif-static');
  let src = $img.attr('src');
  let altsrc = $img.attr('data-altsrc');
  $img.attr('src', altsrc);
  $img.attr('data-altsrc', src);
});

function resizeCompareAccordions () {
  console.log("hello there");
  const summaries = document.querySelectorAll('#compareinstructions [id^="Details-"] summary');
  if (window.matchMedia('(max-width: 989px)').matches) {
    // mobile
    summaries.forEach((summary) => {
      summary.setAttribute('aria-expanded', false);
      summary.parentElement.removeAttribute('open');
    });
  } else {
    // desktop
    summaries.forEach((summary) => {
      summary.setAttribute('aria-expanded',true);
      summary.parentElement.setAttribute('open', true);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  resizeCompareAccordions();
});

/* Refresh Yotpo Widget */
function refreshYotpoWidgets(){
  let yotpoApi = new Yotpo.API(yotpo);
  yotpoApi.refreshWidgets();
}